<template>
  <div class="items-end">
    <NotFoundData
      text="Dados indisponíveis no momento!"
      v-if="!series.length"
    />
    <!-- <PieChart
        :chart-data="chartData"
        :options="chartOptions"
        v-else
      /> -->
    <div v-else id="chart">
      <apexchart
        type="radialBar"
        height="250"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import PieChart from "@/components/Chart/PieChart";
import { twColors, twFonts } from "@/services/tailwindConfig";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames } from "@/utils/utils";
import { integer } from "vuelidate/lib/validators";

export default {
  name: "ResumoGuiasChart",
  components: { NotFoundData },
  props: {
    values: Object,
    isValor:Boolean
  },

  data() {
    return {
      monthNames,
      loadingChart: true,
      notFoundData: false,
      notFoundMessage: "Não há dados suficiente para exibir o resumo",
      dataCompetencia: new Date(),

    };
  },
  computed: {
    series() {
      return [
        this.formatter(this.values.enviado),
        this.formatter(this.values.aguardando),
        this.formatter(this.values.sem_guia),
      ];
    },
    chartOptions() {
      let data = {
        chart: {
          height: 250,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            offsetX: 30,

            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        colors: ["#1ab7ea", "#0084ff", "#39539E"],
        labels: ["Enviadas", "Pendentes", "Sem Guias"],
        legend: {
          show: true,
          floating: true,
          fontSize: "13px",
          position: "left",
          offsetX: -30,
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },

          itemMargin: {
            vertical: 1,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      };
      if (this.isValor) {
        let sum = this.total;

        data.legend.formatter = function (seriesName, opts) {
              return seriesName + ":  " + Math.round(opts.w.globals.series[opts.seriesIndex] * (sum) / 100) ;
        };
        return data;
      } else {
        data.legend.formatter = function (seriesName, opts) {
          return (
            seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
          );
        };
        return data;
      }
    },
    // chartData() {

    //   }
    // },
    // enviado() {
    //   return this.formatter(this.values.enviado) || 0;
    // },
    // aguardando() {
    //   return this.formatter(this.values.aguardando) || 0;
    // },
    // sem_guia() {
    //   return this.formatter(this.values.sem_guia) || 0;
    // },
    total() {
      let dataArr = [
        this.values.enviado,
        this.values.aguardando,
        this.values.sem_guia,
      ];
      let sum = 0;

      for (var i = 0; i < dataArr.length; i++) {
        sum += parseInt(dataArr[i]);
      }
      return sum;
    },
  },
  methods: {
    formatter(value) {
      console.log(this.total);
      return ((value * 100) / this.total).toFixed(2);
    },
    setDefaultDataCompetencia() {
      const dataCompetencia = moment().subtract("1", "months").set("date", 1);
      this.dataCompetencia = new Date(dataCompetencia);
    },
  },
  beforeMount() {
    this.setDefaultDataCompetencia();
  },
};
</script>
